import { injectService } from '@patsnap/tahiti-core';
import { ref } from 'vue';
import { ClassificationService } from './services/classification-service';

export function useFetchClassification(data: { type: string, value: string}) {
    const isLoading = ref(false);

    const classifications = ref<{ title: string, content: string}[]>([]);

    const classificationService = injectService<ClassificationService>(ClassificationService);

    function fetchClassification(data: { type: string, value: string}) {
        isLoading.value = true;
        classificationService.fetch(data)
            .then(data => {
                classifications.value = data;
            })
            .finally(() => {
                isLoading.value = false;
            });
    }

    fetchClassification(data);

    return {
        isLoading,
        classifications,
    };
}
